const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio",
            postponed: "Pospuestos"
          },
          waiting: {
            title: "Pendiente por atender"
          },
          closed: {
            title: "Finalizados hoy"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
          farewellMessage: "Mensaje automático al cerrar",
          provider: "Método de conexión",
          providerHelp:
            "Elige cómo se conecta esta línea a WhatsApp. No se puede cambiar después de creada.",
          providerLockedHelp:
            "El método de conexión no se puede cambiar después de crear la línea.",
          providerOptions: {
            wwebjs: "Estándar (recomendado) — whatsapp-web.js",
            whaileys: "Alterno (experimental) — Baileys",
          },
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
        nameSources: {
          manual: "Editado manualmente",
          whatsapp_verified: "Nombre comercial o verificado",
          whatsapp_profile: "Perfil de WhatsApp",
          whatsapp_address_book: "Agenda de WhatsApp",
          provisional: "Nombre provisional",
          legacy: "Nombre existente protegido",
        },
        nameSourceHelp: {
          manual: "Nombre escrito o corregido manualmente. WhatsApp no lo reemplazará.",
          whatsapp_verified: "Nombre comercial o verificado informado por WhatsApp.",
          whatsapp_profile: "Nombre público configurado por la persona en su perfil de WhatsApp.",
          whatsapp_address_book: "Nombre guardado en la agenda de la conexión de WhatsApp.",
          provisional: "Nombre provisional: normalmente es el número telefónico. Puede reemplazarse cuando WhatsApp proporcione un nombre mejor.",
          legacy: "Nombre que ya existía antes de registrar su origen. Se conserva para evitar cambios accidentales.",
        },
      },
      contactImport: {
        title: "Importar contactos de WhatsApp Business",
        description: "Selecciona una conexión, revisa la vista previa y elige únicamente los contactos que deseas importar. Ningún nombre manual será reemplazado.",
        connection: "Conexión de WhatsApp",
        loadPreview: "Cargar vista previa",
        noConnections: "No hay conexiones de WhatsApp activas disponibles.",
        search: "Buscar por nombre o número",
        statusFilter: "Estado en Whaticket",
        sourceFilter: "Origen del nombre",
        source: {
          all: "Todos los orígenes",
          addressBook: "Agenda guardada",
          named: "Todos con nombre",
          verified: "Comercial o verificado",
          profile: "Perfil de WhatsApp",
          provisional: "Solo números / sin nombre",
        },
        selectRecommended: "Seleccionar recomendados",
        recommendedHelp: " Selecciona contactos nuevos y nombres provisionales que pueden mejorarse.",
        bulkPhotoWarning: " En selecciones mayores de 100 se omite la consulta individual de fotos para evitar una espera excesiva; las fotos existentes se conservan.",
        rowsPerPage: "Filas por página",
        duplicatesInSource: "{{count}} registros consolidados",
        protectedName: "Se conservará el nombre existente: {{name}}",
        status: {
          all: "Todos",
          new: "Nuevo",
          update: "Actualizar nombre",
          existing: "Ya existe",
          protected: "Nombre protegido",
        },
        statusHelp: {
          all: "Muestra todos los contactos, sin importar su situación actual en Whaticket.",
          new: "El número está disponible en WhatsApp, pero todavía no existe como contacto en Whaticket.",
          update: "El contacto existe con un nombre provisional y WhatsApp encontró un nombre mejor.",
          existing: "El contacto ya existe en Whaticket y no necesita cambios de nombre.",
          protected: "El contacto tiene un nombre manual o anterior que Whaticket conservará sin sobrescribirlo.",
        },
        sourceHelp: {
          all: "Muestra los contactos sin limitar la procedencia del nombre.",
          addressBook: "Es la señal más confiable de que el contacto está guardado en la agenda asociada a esta conexión.",
          named: "Muestra cualquier contacto con nombre, aunque ese nombre no necesariamente esté guardado en la agenda.",
          verified: "WhatsApp conoce públicamente el nombre del negocio; no garantiza que el operario lo tenga guardado.",
          profile: "La propia persona configuró este nombre en su perfil; puede no estar guardada en la agenda.",
          provisional: "WhatsApp solo entregó el número. Suele corresponder a conversaciones ocasionales o contactos sin nombre disponible.",
        },
        summary: {
          available: "Disponibles",
          new: "Nuevos",
          update: "Actualizables",
          existing: "Existentes",
          protected: "Protegidos",
          duplicates: "Duplicados unidos",
          skipped: "Grupos o IDs omitidos",
        },
        summaryHelp: {
          available: "Total de teléfonos únicos utilizables. Es la suma de Nuevos, Actualizables, Existentes y Protegidos; no es un grupo adicional.",
          new: "Teléfonos que WhatsApp entregó y que todavía no existen como contactos en Whaticket.",
          update: "Contactos existentes cuyo nombre provisional puede reemplazarse de forma segura por uno mejor.",
          existing: "Contactos que ya existen y no necesitan cambiar su nombre.",
          protected: "Contactos existentes con un nombre manual o anterior que Whaticket no sobrescribirá.",
          duplicates: "Registros repetidos del mismo teléfono encontrados en la conexión y unidos en una sola fila; no se crearán duplicados.",
          skipped: "Grupos e identificadores internos LID que WhatsApp usa para representar contactos, pero que no contienen un teléfono importable. Un número alto puede ser normal.",
        },
        table: {
          name: "Nombre disponible",
          number: "Número",
          status: "Resultado previsto",
        },
        cancel: "Cancelar",
        close: "Cerrar",
        importing: "Importando...",
        importSelected: "Importar seleccionados ({{count}})",
        completed: "Importación de contactos terminada.",
        resultTitle: "Resultado de la importación",
        result: "Creados: {{created}} · Actualizados: {{updated}} · Nombres protegidos: {{protected}} · Sin cambios: {{unchanged}} · Errores: {{errors}} · Fotos omitidas por importación masiva: {{photosSkipped}}",
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          countryCode: "Código país",
          number: "Número de Whatsapp",
          numberHint: "Escribe el número sin el prefijo. El sistema lo guardará con código país.",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Nueva área de atención",
          edit: "Editar área de atención",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Áreas de atención",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a otra área",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione un área",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Por atender",
        assignedHeader: "En atención",
        attentionRequired: "Requiere atención",
        noAttentionPending: "No hay tickets por atender",
        attended: "Atendidos",
        internalTag: "Interna",
        closedTag: "Cerrado",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        lastSender: {
          customer: "El cliente envió el último mensaje",
          operator: "El operario envió el último mensaje",
          unknown: "No se conoce quién envió el último mensaje",
        },
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Aceptar",
          reject: "Rechazar",
        },
        postpone: {
          button: "Posponer",
          activeUntil: "Pospuesto hasta {{date}}",
          fifteenMinutes: "15 minutos",
          thirtyMinutes: "30 minutos",
          oneHour: "1 hora",
          twoHours: "2 horas",
          tomorrow: "Hasta mañana",
          more: "Más tiempo…",
          toastMessage: "Pospuesto {{label}}",
          undo: "Deshacer",
          undoSuccess: "Se deshizo la posposición",
          customTitle: "Posponer por más tiempo",
          amountLabel: "Cantidad",
          unitLabel: "Unidad",
          units: {
            minutes: "Minutos",
            hours: "Horas",
            days: "Días",
          },
          confirm: "Posponer",
          cancel: "Cancelar",
          invalidAmount: "Escribe una cantidad válida",
          noResponseNeeded: "No requiere respuesta",
          noResponseSuccess: "Marcado como que no requiere respuesta",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Tickets",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Áreas de atención",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
        },
        appBar: {
          user: {
            profile: "Perfil",
            notifications: "Sonido de notificaciones",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      notificationSound: {
        title: "Sonido de notificaciones",
        enabled: "Reproducir sonido",
        enabledHelp: "Esta opción solo controla el sonido de Whaticket en este navegador.",
        tone: "Tono",
        tones: {
          soft: "Suave (recomendado)",
          discreet: "Discreto",
          classic: "Actual",
        },
        volume: "Volumen de Whaticket",
        repeatInterval: "Intervalo mínimo entre sonidos",
        intervals: {
          everyMessage: "En cada mensaje",
        },
        seconds: "segundos",
        repeatHelp: "Si llegan varios mensajes seguidos, el aviso sonará como máximo una vez durante este intervalo.",
        test: "Probar sonido",
        cancel: "Cancelar",
        save: "Guardar",
      },
      phoneConversation: {
        title: "Abrir conversación por número",
        help: "Revise el número y elija desde cuál conexión de WhatsApp desea atender la conversación.",
        number: "Número telefónico",
        countryCode: "Código de país",
        countryHelp: "Para Colombia use 57. Si el número ya incluye el país, no se duplicará.",
        name: "Nombre del contacto (opcional)",
        connection: "Enviar desde la conexión",
        noConnections: "No hay conexiones de WhatsApp activas.",
        noAutomaticMessage: "Se abrirá el ticket, pero no se enviará ningún mensaje automáticamente.",
        copy: "Copiar",
        copied: "Número copiado.",
        copyError: "No fue posible copiar el número.",
        cancel: "Cancelar",
        start: "Abrir conversación",
      },
      queues: {
        title: "Áreas de atención",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Crear área",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa área seguirán existiendo, pero ya no tendrán ninguna área asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Áreas de atención",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán al área.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          businessDayStartHour: {
            name: "Hora de inicio de jornada",
          },
          businessWorkingDays: {
            name: "Días laborales",
            days: {
              0: "Dom",
              1: "Lun",
              2: "Mar",
              3: "Mié",
              4: "Jue",
              5: "Vie",
              6: "Sáb",
            },
          },
          oldTicketsReminder: {
            name: "Recordatorio de tickets antiguos",
            enabledLabel: "Activar recordatorio",
            options: {
              enabled: "Activado",
              disabled: "Desactivado",
            },
            thresholdDaysLabel: "Días sin actividad para considerarlo antiguo",
            intervalMinutesLabel: "Intervalo entre recordatorios (minutos)",
          },
          postReplySnooze: {
            name: "Posponer después de responder",
            secondsLabel: "Tiempo disponible (segundos, 0 desactiva)",
          },
        },
      },
      oldTicketsReminder: {
        title: "Tickets abiertos antiguos",
        message:
          "Tienes {{count}} ticket abierto con más de {{days}} días sin actividad. Recuerda revisarlo y cerrarlo cuando corresponda.",
        message_plural:
          "Tienes {{count}} tickets abiertos con más de {{days}} días sin actividad. Recuerda revisarlos y cerrarlos cuando corresponda.",
        accept: "Aceptar",
      },
      messagesList: {
        download: "Descargar",
        downloading: "Descargando…",
        downloadError: "No fue posible descargar el archivo. Intente nuevamente.",
        history: {
          previousTicket: "Conversación anterior · ticket #{{ticketId}}",
          currentTicket: "Conversación actual · ticket #{{ticketId}}",
        },
        delivery: {
          pending: "Enviando o esperando confirmación de WhatsApp",
          failed: "Envío no confirmado. Verifique antes de volver a enviarlo",
        },
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            reject: "Rechazar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        sendImagesAsHd: "Enviar imágenes en HD",
        sendImagesAsHdHelp: "Mayor calidad; el envío puede tardar un poco más.",
        mediaCaptionPlaceholder: "Agregar un comentario",
        sendContactCard: "Enviar contacto",
        contactCardTitle: "Enviar tarjeta de contacto",
        contactCardSearch: "Buscar por nombre o número",
        contactCardSend: "Enviar contacto",
        contactCardCancel: "Cancelar",
        contactCardSent: "Tarjeta de contacto enviada.",
        emojis: "Emojis",
        attachFiles: "Adjuntar archivos",
        sendLocation: "Enviar ubicación",
        locationTitle: "Enviar ubicación",
        locationUseCurrent: "Usar mi ubicación actual",
        locationLocating: "Obteniendo ubicación…",
        locationLatitude: "Latitud",
        locationLongitude: "Longitud",
        locationName: "Nombre del lugar (opcional)",
        locationAddress: "Dirección (opcional)",
        locationHelp: "Puede copiar las coordenadas desde Google Maps.",
        locationPreview: "Ubicación seleccionada",
        locationOpenMap: "Revisar mapa",
        locationSend: "Enviar ubicación",
        locationCancel: "Cancelar",
        locationSent: "Ubicación enviada.",
        locationUnavailable: "Este navegador no permite obtener la ubicación.",
        locationPermissionError: "No fue posible obtener la ubicación. Revise el permiso del navegador o escriba las coordenadas.",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        phoneUnavailable: "El cliente no compartió su número de teléfono",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      ticketMute: {
        title: "Silenciar conversación",
        description: "Elige durante cuánto tiempo Whaticket no reproducirá sonidos ni mostrará avisos de escritorio para esta conversación.",
        eightHours: "8 horas",
        oneWeek: "1 semana",
        forever: "Siempre",
        syncWarning: "Whaticket intentará sincronizar este cambio con WhatsApp Business. Si WhatsApp no lo acepta, el silencio seguirá funcionando solo en Whaticket.",
        cancel: "Cancelar",
        confirm: "Silenciar",
        mute: "Silenciar conversación",
        unmute: "Reactivar notificaciones",
        muted: "Silenciada",
        synced: "Conversación silenciada en Whaticket y WhatsApp.",
        localOnly: "Conversación silenciada solo en Whaticket; WhatsApp no confirmó el cambio.",
        unmutedSynced: "Notificaciones reactivadas en Whaticket y WhatsApp.",
        unmutedLocalOnly: "Notificaciones reactivadas en Whaticket; WhatsApp no confirmó el cambio.",
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        open: "Opciones del mensaje",
        delete: "Borrar",
        forward: "Reenviar",
        reply: "Responder",
        react: "Reaccionar",
        pin: "Fijar mensaje",
        unpin: "Desfijar mensaje",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      messageReaction: {
        title: "Reaccionar al mensaje",
        remove: "Quitar mi reacción",
        cancel: "Cancelar",
      },
      messagePin: {
        title: "Fijar mensaje",
        description: "Elige durante cuánto tiempo permanecerá fijado en esta conversación de WhatsApp.",
        oneDay: "24 horas",
        sevenDays: "7 días",
        thirtyDays: "30 días",
        cancel: "Cancelar",
        confirm: "Fijar",
        synced: "Mensaje fijado y sincronizado con WhatsApp.",
        localOnly: "Mensaje fijado solo en Whaticket; WhatsApp no pudo sincronizarlo.",
        unpinnedSynced: "Mensaje desfijado en Whaticket y WhatsApp.",
        unpinnedLocalOnly: "Mensaje desfijado en Whaticket; WhatsApp no pudo confirmar el cambio.",
      },
      pinnedMessages: {
        title: "Mensajes fijados",
        pinned: "Mensaje fijado",
        until: "hasta",
        image: "Imagen",
        audio: "Audio",
        video: "Video",
        location: "Ubicación",
        contact: "Contacto",
        message: "Mensaje",
        you: "Tú",
        synced: "Sincronizado con WhatsApp",
        localOnly: "Solo en Whaticket",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        fieldLabel: "Buscar ticket de destino",
        noOptions: "No se encontraron tickets disponibles",
        ticketHint: "Busca por cliente, número, área o ticket.",
        queue: "Área",
        channel: "Canal",
        assignedTo: "Asignado",
        unassigned: "Sin asignar",
        success: "Mensaje reenviado correctamente.",
        buttons: {
          cancel: "Cancelar",
          ok: "Reenviar",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_REACT_WAPP_MSG: "No se pudo reaccionar al mensaje de WhatsApp.",
        ERR_INVALID_REACTION: "La reacción seleccionada no es válida.",
        ERR_PIN_WAPP_MSG: "No se pudo fijar o desfijar el mensaje en WhatsApp.",
        ERR_PIN_NOT_SUPPORTED: "La conexión seleccionada no permite fijar mensajes.",
        ERR_INVALID_PIN_DURATION: "El periodo seleccionado para fijar el mensaje no es válido.",
        ERR_INVALID_PIN_REQUEST: "La solicitud para fijar el mensaje no es válida.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_MESSAGE_FOUND: "No se encontró ningún mensaje con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_INVALID_FORWARD_TARGET:
          "Seleccione un ticket abierto o pendiente antes de reenviar este mensaje.",
        ERR_FORWARD_MEDIA_NOT_FOUND:
          "No se encontró el archivo original de esta multimedia para reenviarlo.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de un área.",
        ERR_WAPP_INVALID_PROVIDER:
          "El método de conexión elegido no es válido.",
      },
    },
  },
};

export { messages };
